(function () {
    'use strict';

    angular
        .module('tikonApp')
        .controller('ServiceItemListV2Controller', ServiceItemListV2Controller);

    ServiceItemListV2Controller.$inject = ['$scope', '$state', '$stateParams', '$location', 'ServiceItem', 'ServiceItemSearch', 'ParseLinks', 'AlertService', 'pagingParams', 'paginationConstants', 'ServiceItemCustom', '$translate', '$uibModal', 'QueryParamsService'];

    function ServiceItemListV2Controller($scope, $state, $stateParams, $location, ServiceItem, ServiceItemSearch, ParseLinks, AlertService, pagingParams, paginationConstants, ServiceItemCustom, translate, $uibModal, QueryParamsService) {
        var vm = this;
        //

        var type = $stateParams.type;
        if (type == 'class') {
            $state.current.url = '/classes';
        } else {
            type = 'service';
        }

// alert(type);
        vm.loadPage = loadPage;
        vm.predicate = pagingParams.predicate;
        vm.reverse = pagingParams.ascending;
        vm.transition = transition;
        vm.clear = clear;
        vm.search = search;
        vm.searchQuery = pagingParams.search;
        vm.currentSearch = pagingParams.search;
        vm.pageSize = 3;
        vm.findStatusStyle = findStatusStyle;
        vm.findStatusIcon = findStatusIcon;
        vm.categoryName = categoryName;

        vm.editServiceItem = editServiceItem;
        vm.searchServiceItem = searchServiceItem;
        vm.searchKeyPress = searchKeyPress;
        vm.newServiceItem = newServiceItem;
        vm.clearSearch = clearSearch;
        vm.showEducation = showEducation


        // vm.copyServiceItem = copyServiceItem;

        loadAll();
        loadPage();

        function loadAll() {
            //
            //if (pagingParams.search) {
            //    ServiceItemSearch.query({
            //
            //        query: pagingParams.search,
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //} else {
            //    ServiceItem.query({
            //        page: pagingParams.page - 1,
            //        size: paginationConstants.itemsPerPage,
            //        sort: sort()
            //    }, onSuccess, onError);
            //}


            //

            function sort() {
                var result = [vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc')];
                if (vm.predicate !== 'id') {
                    result.push('id');
                }
                return result;
            }

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                vm.queryCount = vm.totalItems;
                vm.serviceItems = data;
                vm.page = pagingParams.page;
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function loadPage() {
            loadServiceItems();
        }

        function loadServiceItems() {
            ServiceItemCustom.getServiceItemByCurrentCompanyAndServiceMode('RESERVE').query().$promise.then(function(res){
                vm.serviceItems = res;
                 var newFilters = QueryParamsService.getFilters();
                if(newFilters.searchText){
                        vm.searchQuery = newFilters.searchText;
                        searchServiceItem()
                }
            })
        }

        function transition() {
            $state.transitionTo($state.$current, {
                page: vm.page,
                sort: vm.predicate + ',' + (vm.reverse ? 'asc' : 'desc'),
                search: vm.currentSearch
            });
        }

        function search(searchQuery) {
            if (!searchQuery) {
                return vm.clear();
            }
            vm.links = null;
            vm.page = 1;
            vm.predicate = '_score';
            vm.reverse = false;
            vm.currentSearch = searchQuery;
            vm.transition();
        }

        function clear() {
            vm.links = null;
            vm.page = 1;
            vm.predicate = 'id';
            vm.reverse = true;
            vm.currentSearch = null;
            vm.transition();
        }

        function findStatusStyle(serviceStatus) {
            return "service-item-status-" + serviceStatus;
        }

        function findStatusIcon(serviceStatus) {
            if (serviceStatus == "DISABLE") {
                return "glyphicon glyphicon-ban-circle";
            }
            if (serviceStatus == "PUBLISH") {
                return "glyphicon glyphicon-ok";
            }
            if (serviceStatus == "PUBLISH_JUST_PANEL") {
                return "glyphicon glyphicon-lock";
            }
            if (serviceStatus == "RESERVE_JUST_PANEL") {
                return "glyphicon glyphicon-eye-open";
            }

        }

        function categoryName(name) {
            if (name == "DEFAULT_CATEGORY")
                return translate.instant('tikonApp.serviceItem.' + name);
            else
                return name;
        }


        function editServiceItem(item) {
            $state.go('supplierPanel-v2.serviceItemList.serviceItem', {id: item.id});
        }

        function searchServiceItem() {

            if (!vm.searchQuery) {
                QueryParamsService.removeFilter('searchText')
                loadServiceItems();
                return;
            }else QueryParamsService.updateFilter('searchText', vm.searchQuery)
            vm.serviceItems = vm.serviceItems.filter(function (srv) {
                if (srv.itemTitle.includes(vm.searchQuery) ||
                    srv.category.categoryName.includes(vm.searchQuery)
                )
                    return true;
            })
        }

        function searchKeyPress(keyEvent) {
            if (keyEvent.which === 13) {
                searchServiceItem();
            }
        }

        function newServiceItem() {
            $state.go('supplierPanel-v2.serviceItemList.serviceItem');
        }

        function clearSearch() {
            vm.searchQuery = null;
            QueryParamsService.removeFilter('searchText')
            loadServiceItems();
        }
         function showEducation() {
            $uibModal.open({
                templateUrl: 'app/components/modal/educationMovie.html',
                controller: 'EducationMovieController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    link: function () {
                        return '<div id="99431983546"><script type="text/JavaScript" src="https://www.aparat.com/embed/rhu4h4t?data[rnddiv]=99431983546&data[responsive]=yes&titleShow=true&autoplay=true"></script></div>'
                    },
                }
            }).result.then(function () {
                // $state.go('^');
            }, function () {
                // $state.go('^');
            });
        }
    }
})();